import FrontPage from './components/FrontPage.vue'
import ComponentPage from './components/ComponentPage.vue'
import ErrorPage from './components/ErrorPage.vue'

export const routes = [
    // { name: 'frontpage', path: '/', redirect: '/:componentId*' },
    // { name: 'componentpage', path: ':componentPage/:componentId*', component: ComponentPage }, // e.g. :8443/tukapage#/tukacontent/1/3
    { name: 'componentpage', path: '/:componentId*', component: ComponentPage }, // e.g. :8443/tukacontent#/1/3
    { name: '404', path: '*', component: ErrorPage }
];
